import { DropdownItem, LookupModelSearchEvent } from "@mcleod/components";
import { getDispatchControlBoolean } from "@mcleod/general";
import { AutogenLayoutCarrierRevenueReport } from "./autogen/AutogenLayoutCarrierRevenueReport";

export class CarrierRevenueReport extends AutogenLayoutCarrierRevenueReport {
    private _containerEnabled: boolean;

    override onLoad(): void | Promise<void> {
        this._containerEnabled = getDispatchControlBoolean("is_container_active", false);
        this.toggleContainerEnabled(this._containerEnabled);

        this.textbox1.items = [new DropdownItem("B", "Bill Date(s)"), new DropdownItem("S", "Ship Date(s)"), new DropdownItem("D", "Delivery Date(s)")];
        this.textboxSortBy.items = [new DropdownItem("Name", "Name"), new DropdownItem("Code", "Code"), new DropdownItem("Revenue", "Revenue")];
        this.textboxInclude.items = [new DropdownItem("B", "Container and Non-container"), new DropdownItem("C", "Container Only"), new DropdownItem("N", "Non-container Only")];

        this.textbox1.selectedItem = this.textbox1.items[0]; // Bill Date(s)
        this.textboxSortBy.selectedItem = this.textboxSortBy.items[0]; // Name
        this.textboxInclude.selectedItem = this.textboxInclude.items[0]; // Container and Non-container
    }

    private toggleContainerEnabled(isEnabled: boolean) {
        this.excludabletextbox2.enabled = isEnabled;
        this.excludabletextbox2.visible = isEnabled;
        this.textboxInclude.enabled = isEnabled;
        this.textboxInclude.visible = isEnabled;
        this.excludabletextbox1.rowBreak = isEnabled;
    }

    textboxSteamshipLinesBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_steamship = "Y"
    }

}
